export default process.env.VUE_APP_AZURE_ACTIVE_DIRECTORY_URL;
